const Gender: { [key: string]: string } = {
  M: 'Man',
  V: 'Vrouw',
  O: 'Onbekend',
};

export default Gender;
